export default "__VITE_ASSET__CQZXmBwn__"